import { PatientListSearch } from "../types";

/** Page size for HD patient pickers on GET /api/client/v1/clients/patients/ */
export const PATIENT_LIST_PAGE_SIZE = 20;

/** Combobox replaces chips when the household is larger than this */
export const PATIENT_SEARCH_DROPDOWN_THRESHOLD = 10;

export const urls = {
  // profile
  profile: () => "/api/client/v1/accounts/profile/",
  profileLookup: () => "/api/client/v1/accounts/lookup/",
  // password management
  completeSignup: () => "/api/client/v1/accounts/profile/complete-signup/",
  updatePassword: () => "/api/client/v1/accounts/profile/update-password/",
  resetPassword: () => "/api/client/v1/accounts/reset-password/",
  // login
  login: () => "/api/client/v1/accounts/signin/",
  signup: () => "/api/client/v1/accounts/verify-sign-up/",
  sendVerificationCode: () => "/api/client/v1/accounts/send-verification-code/",
  // validation
  verifyLoginPhoneNumber: () => "/api/client/v1/accounts/signin-phone-numbers/verify/",
  // Phone
  primaryPhone: () => "/api/client/v1/accounts/primary-phone/",
  // client
  client: () => "/api/client/v1/clients/client/",
  // clientUser
  clientUser: () => "/api/client/v1/clients/clientuser/",
  // addresses
  addresses: () => "/api/client/v1/accounts/addresses/",
  address: (id: number) => `/api/client/v1/accounts/addresses/${id}/`,
  addressVerify: () => "/api/client/v1/accounts/addresses/verify/",
  // patients
  patients: () => "/api/client/v1/clients/patients/",
  patient: (id: number) => `/api/client/v1/clients/patients/${id}/`,
  patientBreeds: () => `/api/client/v1/clients/patients/breeds/`,
  patientColors: () => `/api/client/v1/clients/patients/colors/`,
};

export const keys = {
  /** all queries in the accounts namespace */
  all: () => ["accounts-all"],
  // clients
  clients: () => [...keys.all(), "clients"],
  clientDetails: () => [...keys.clients(), "detail"],
  activeClientDetail: () => [...keys.clientDetails(), "active"],
  // clientUsers
  clientUsers: () => [...keys.all(), "clientUsers"],
  clientUserDetails: () => [...keys.clientUsers(), "detail"],
  activeClientUserDetail: () => [...keys.clientUserDetails(), "active"],
  // patients
  patients: () => [...keys.all(), "patients"],
  patientLists: () => [...keys.patients(), "list"],
  patientList: (search: PatientListSearch) => [...keys.patientLists(), search],
  patientDetails: () => [...keys.patients(), "detail"],
  patientDetail: (id: number) => [...keys.patientDetails(), id],
  // patient breeds
  patientBreeds: () => [...keys.all(), "breeds"],
  patientBreedsLists: () => [...keys.all(), "list"],
  patientBreedsList: () => [...keys.patientBreedsLists()],
  // patient colors
  patientColors: () => [...keys.all(), "colors"],
  patientColorsLists: () => [...keys.all(), "list"],
  patientColorsList: () => [...keys.patientColorsLists()],
  // validation
  validation: () => [...keys.all(), "validation"],
  loginPhoneNumberValidations: () => [...keys.validation(), "login-phone-number"],
  loginPhoneNumberValidation: (opts: { number: string }) => [
    ...keys.loginPhoneNumberValidations(),
    opts,
  ],
};
